import { IBaseMap } from "@/types";

export const useGoogleBaseMaps = (licenceKey: string) =>
  [
    {
      name: "Roadmap",
      url: "m",
    },
    {
      name: "Terrain",
      url: "p",
    },
    {
      name: "Aerial",
      url: "s",
    },
    {
      name: "Hybrid",
      url: "y",
    },
  ].map((m) => ({
    ...m,
    url: `https://mt1.google.com/vt/lyrs=${m.url}&hl=en&x={x}&y={y}&z={z}`,
    type: "Google",
    isDefault: false,
    licenceKey,
    attribution: "@ Google",
  })) as IBaseMap[];
